
const modules = import.meta.glob('./*/*.ts', { eager: true });

const messages: Record<string, { translation: Record<string, string> }> = {};

Object.keys(modules).forEach((path) => {
  const match = path.match(/\.\/([^/]+)\/([^/]+)\.ts$/);
  if (match) {
    const [, lang] = match;
    const module = modules[path] as Record<string, unknown>;

    if (!messages[lang]) {
      messages[lang] = { translation: {} };
    }

    // Handle named exports (no default export)
    const { default: _default, ...namedExports } = module;
    const namedStrings = Object.fromEntries(
      Object.entries(namedExports).filter(([, v]) => typeof v === 'string')
    ) as Record<string, string>;

    if (_default && typeof _default === 'object') {
      messages[lang].translation = {
        ...messages[lang].translation,
        ...(_default as Record<string, string>),
      };
    }

    messages[lang].translation = {
      ...messages[lang].translation,
      ...namedStrings,
    };
  }
});

export default messages;
